import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import 'animate.css/animate.min.css';
import './FullPageLoader.scss';

// import { uniq } from 'lodash';
import ErrorPage from './ErrorPage';
import config from '../../../config/config';
import If from '../If/If';
import Loader from '../Loader/Loader';
import Phone from '../Phone/Phone';
import { AutoExchange } from '../../../redux/modules/autoExchange/actionTypes';

import { getHasCollegeOnly } from '../../../redux/modules/productTypes/productType.selectors';
import {
  ADDRESS_INCOMPLETE,
  ANY_STOP_TRANSFER,
  APP_FAILURE,
  COLLEGE_CLIENT_ONLY,
  COLLEGE_BUY_REDIRECT,
  COLLEGE_EXCHANGE_REDIRECT,
  COLLEGE_SELL_REDIRECT,
  COLLEGE_FUND_NOTE_PHONE_NUMBERS,
  DOB_FAILURE,
  EXCHANGE_TO_EXISTING_LOAD_FAILED,
  FOREIGN_ADDRESS,
  NON_ELIGIBLE_AGREEMENTS,
  NOT_RETAIL_CLIENT,
  PURCHASE_FAILURE,
  RELOAD_FAILURE,
  TIMEOUT,
  TRAC_OR_RPS_ONLY,
  ZERO_BALANCE_FUND,
  RECURRING_PURCHASE_FAILURE,
  RECURRING_PURCHASE_APP_FAILURE,
  ROTH_CONVERSION_NO_ELIGIBLE_FUNDS,
  ROTH_CONVERSION_NO_ELIGIBLE_BENES,
  NO_ELIGIBLE_FUNDS_IRAS_IRA_AUTOMAX,
  NO_IRA_AUTO_MAX_FUNDS,
  PURCHASE_FAILURE_IRA_AUTOMAX,
  QCD_ZERO_STATE,
  MD529_DECOMMISSION,
  MD529_DECOMMISSION_ZERO_STATE,
  CUSTODIAN_ONLY,
} from '../../../settings/settings';
import {
  isBuy,
  isCollegeContribute,
  isCollegeDistribute,
  isCollegeExchange,
  isExchange,
  isIRAAutoMax,
  isQCD,
  isSell,
} from '../../../utils/transactions-util';
import words from '../../../utils/words';
import Button from '../Button/Button';
import { isNull, isUndefined } from 'lodash';
import { appendBasePath } from '../../../utils/nav.utils';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { PRODUCT_TYPE_ENUM_MAP } from '../../../settings/settings';

export class FullPageLoader extends Component {
  static defaultProps = {
    errorType: APP_FAILURE,
    isVisible: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      messageID: null,
      message: '',
      messageNumber: 0,
      messageLength: 0,
      count: 0,
    };
  }
  componentDidMount() {
    const { messages } = this.props;
    const mID = setInterval(this.handleMessages, 1000);
    this.setState({ messageID: mID }); // eslint-disable-line
    if (!isNull(messages) && !isUndefined(messages)) {
      this.setState({ messageLength: messages.length }); // eslint-disable-line
    }
  }
  componentWillUnmount() {
    clearInterval(this.state.messageID);
  }

  handleMessages = () => {
    const { messages } = this.props;
    if (!isUndefined(messages)) {
      const { count, messageNumber, messageLength } = this.state;
      if (count % 3 === 0) {
        if (messageNumber + 1 > messageLength - 1) {
          this.setState({
            messageNumber: 0,
            message: messages[0],
          });
        } else {
          this.setState({
            messageNumber: messageNumber + 1,
            message: messages[messageNumber + 1],
          });
        }
      }
      this.incrementCount();
    }
  };

  incrementCount = () => {
    const { count } = this.state;
    this.setState({ count: count + 1 });
  };

  render() {
    const { message } = this.state;
    const {
      isSalesforceRep,
      customerWebViewEnabled,
      appError,
      collegePlanType,
      errorType,
      hasError,
      isVisible,
      onRetry = () => {},
      collegeOnlyPlan,
    } = this.props;
    const automaticPath = '/automatic';
    const unableToAddbank = 'Unable to add a bank';
    const noFundsEligibleForIRAMax = 'No Funds Eligible for IRA AutoMax';
    const collegeFlowType = isCollegeExchange()
      ? 'exchange'
      : isCollegeDistribute()
      ? 'distribution'
      : isCollegeContribute()
      ? 'contribution'
      : 'transaction';

    const mfFlowType = isExchange()
      ? 'exchange'
      : isBuy()
      ? 'buy'
      : isSell()
      ? 'sell'
      : isIRAAutoMax()
      ? 'IRA AutoMax'
      : 'transaction';

    const accounts = [];
    accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['MARYLAND_529'] });
    // const products = uniq(accounts.map((a) => a.productType));
    return (
      <div>
        <If test={hasError && !isVisible}>
          {/* App Failure submission error */}
          <If test={errorType === QCD_ZERO_STATE}>
            <ErrorPage
              errorMsg={
                <div className="qcd-error-msg error-msg-lh">
                  <p>This may be because: </p>
                  <ul className={'bulltes-points-rmd-errors'}>
                    <li>You are not at least 70.5 years old</li>
                    <li>
                      You do not own an IRA eligible for QCDs online
                      (Traditional, Rollover, Roth, or Roth Rollover IRA)
                    </li>
                    <li>
                      You do not have a current balance in your eligible IRAs
                    </li>
                    <li>
                      Your eligible IRAs are held in T. Rowe Price Retirement
                      Advisory Service™, T. Rowe Price ActivePlus Portfolios®,
                      or Brokerage Advantage.
                    </li>
                  </ul>
                  <p className={'bulltes-points-rmd-errors'}>
                    In instances where you cannot make a QCD online, please use
                    the{' '}
                    <a
                      className={'error-link'}
                      href={`${config.url}/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      QCD form
                    </a>{' '}
                    or{' '}
                    <a
                      className={'error-link'}
                      rel="noopener noreferrer"
                      href={`${config.url}/personal-investing/help/contact/index.html`}
                      target="_blank"
                    >
                      contact us
                    </a>{' '}
                    with any questions.
                  </p>
                </div>
              }
              heading={
                'Unfortunately, you are not eligible to make a qualified charitable distribution (QCD) online.'
              }
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      {' '}
                      <a
                        className="full-page-loader-retry-link college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                        rel="noopener noreferrer"
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>
          <If test={errorType === APP_FAILURE}>
            <ErrorPage
              errorMsg={
                <div className="error-msg error-msg-lh">
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      Please{' '}
                      {collegeOnlyPlan ? (
                        <span>
                          <a
                            className="college-branded-link full-page-loader-link"
                            href={`${config.url}/personal-investing/help/contact-us.html`}
                          >
                            call us
                          </a>{' '}
                          to speak with a representative or try again later.
                        </span>
                      ) : (
                        <span>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`${config.url}/personal-investing/help/contact/index.html`}
                          >
                            contact us
                          </a>{' '}
                          to speak with a representative or try again later.
                        </span>
                      )}
                    </span>
                  )}
                </div>
              }
              heading={'We are having technical issues loading your page.'}
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      {' '}
                      <a
                        className="full-page-loader-retry-link college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                        rel="noopener noreferrer"
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>

          {/* Purchase failure submission error */}
          <If test={errorType === PURCHASE_FAILURE}>
            <ErrorPage
              errorMsg={
                <div className="full-page-loader-error-msg full-page-loader-error-msg-lh">
                  We encountered a technical error and your transaction was{' '}
                  <span className="full-page-loader-bold-text">
                    not submitted.
                  </span>
                  <br />
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      Please{' '}
                      {collegeOnlyPlan ? (
                        <span>
                          <a
                            className="college-branded-link full-page-loader-link"
                            href={`${config.url}/personal-investing/help/contact-us.html`}
                          >
                            call us
                          </a>{' '}
                        </span>
                      ) : (
                        <span>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`${config.url}/personal-investing/help/contact/index.html`}
                          >
                            contact us
                          </a>{' '}
                        </span>
                      )}
                      to complete this transaction or try again later.
                    </span>
                  )}
                </div>
              }
              heading={`We weren't able to submit your ${
                collegeOnlyPlan ? collegeFlowType : mfFlowType
              }.`}
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      {' '}
                      <a
                        className="full-page-loader-retry-link college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                        rel="noopener noreferrer"
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>
          {/* Purchase failure submission error for IRA AutoMax */}
          <If test={errorType === PURCHASE_FAILURE_IRA_AUTOMAX}>
            <ErrorPage
              errorMsg={
                <div className="full-page-loader-error-msg full-page-loader-error-msg-lh">
                  We encountered a technical error and your transaction was{' '}
                  <span className="full-page-loader-bold-text">
                    not submitted.
                  </span>
                  <br />
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      Please{' '}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`${config.url}/personal-investing/help/contact/index.html`}
                      >
                        contact us
                      </a>{' '}
                      to complete this transaction or try again later.
                    </span>
                  )}
                </div>
              }
              hasError={hasError}
              heading={`We weren't able to submit your ${mfFlowType}.`}
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      {' '}
                      <a
                        className="full-page-loader-retry-link college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>
          {/* Purchase failure submission error for IRA AutoMax */}
          <If test={errorType === PURCHASE_FAILURE_IRA_AUTOMAX}>
            <ErrorPage
              errorMsg={
                <div className="full-page-loader-error-msg full-page-loader-error-msg-lh">
                  We encountered a technical error and your transaction was{' '}
                  <span className="full-page-loader-bold-text">
                    not submitted.
                  </span>
                  <br />
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      Please{' '}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`${config.url}/personal-investing/help/contact/index.html`}
                      >
                        contact us
                      </a>{' '}
                      to complete this transaction or try again later.
                    </span>
                  )}
                </div>
              }
              heading={`We weren't able to submit your ${mfFlowType}.`}
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      {' '}
                      <a
                        className="full-page-loader-retry-link college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                        rel="noopener noreferrer"
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>
          <If test={errorType === AutoExchange.VALIDATION_FAILURE}>
            <ErrorPage
              errorMsg={
                "Don't worry, your trade has not been submitted and no transaction has taken place."
              }
              heading="We’re sorry, something went wrong on our side."
              retryMsg={
                <div>
                  Please{' '}
                  <span
                    className="retry-submit"
                    id="retry-link-submission"
                    onClick={() => onRetry()}
                    styleName="link"
                  >
                    try again
                  </span>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      , or call an associate at 1-800-775-0187 to place your
                      trade over the phone.
                    </span>
                  )}
                </div>
              }
            />
          </If>

          {/* Reload failure submission error */}
          <If test={errorType === RELOAD_FAILURE}>
            <ErrorPage
              errorMsg={
                'Your transaction has been updated and will display on the Automatic Transactions page when we get this fixed, or you can try refreshing the page.'
              }
              heading={'We are having technical issues loading your page.'}
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span className="error-page-block-element error-page-mr-bottom2">
                      <a
                        className="full-page-loader-retry-link college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                  <Button
                    id={
                      appError ? 'retry-button-app' : 'retry-button-submission'
                    }
                    onClick={() =>
                      // eslint-disable-next-line no-restricted-globals
                      location.reload(true)
                    }
                    buttonType="secondary"
                    className="full-page-loader-retry-btn"
                  >
                    <img
                      alt=""
                      src="assets/images/refresh_icon.svg"
                      className="full-page-loader-retry-img"
                    />
                    <span className="full-page-loader-retry-btn-txt">
                      Refresh
                    </span>
                  </Button>
                </div>
              }
            />
          </If>

          {/* TRAC client trying to access personal investing site */}
          <If test={errorType === NOT_RETAIL_CLIENT}>
            <ErrorPage
              errorMsg={'You are trying to access the personal investing site.'}
              heading={
                <div className="full-page-loader-errorHeader">
                  Looking For Your Workplace Retirement Account?
                </div>
              }
              retryMsg={
                <div>
                  <div className="full-page-loader-space">
                    <a
                      className="full-page-loader-link"
                      href={`${config.url}/rps/rws/account/participant/home/overview.otc`}
                    >
                      Go To Workplace Retirement
                    </a>
                  </div>
                  <br />
                  <div className="full-page-loader-space">
                    <a
                      className="full-page-loader-retry-link retry-pad college-branded-link"
                      href={`${config.rmlUrl}/usis/nasu/account-finder`}
                    >
                      Open Personal Investing Account
                    </a>
                  </div>
                </div>
              }
            />
          </If>

          <If
            test={
              errorType === RECURRING_PURCHASE_FAILURE ||
              errorType === AutoExchange.FAILURE
            }
          >
            <ErrorPage
              errorMsg={''}
              heading={'We’re sorry, something went wrong on our side.'}
              retryMsg={
                <div className="retry-msg">
                  Please review your transactions on the{' '}
                  <a
                    className="link"
                    href={`${config.url}${appendBasePath(automaticPath)}`}
                  >
                    Automatic Transactions Page
                  </a>
                  , or{' '}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${config.url}/personal-investing/help/contact/index.html`}
                  >
                    contact us
                  </a>{' '}
                  to set up your transaction over the phone
                </div>
              }
            />
          </If>

          {/* Recurring Purchase App failure submission error */}
          <If test={errorType === RECURRING_PURCHASE_APP_FAILURE}>
            <ErrorPage
              errorMsg={''}
              heading={'We’re sorry, something went wrong on our side.'}
              retryMsg={
                <div>
                  Please review your transactions on the{' '}
                  <a
                    className="link"
                    href={`${config.url}${appendBasePath(automaticPath)}`}
                  >
                    Automatic Transactions Page
                  </a>
                  , or call an associate at{' '}
                  <Phone phoneNumber="(855) 787-9140" /> to set up your
                  transaction over the phone
                </div>
              }
            />
          </If>

          {/* Missing DOB submission error */}
          <If test={errorType === DOB_FAILURE}>
            <ErrorPage
              errorMsg={
                "The owner's date of birth is required to transact using this account"
              }
              heading={'Missing Information: Date of Birth'}
              retryMsg={
                <div>
                  Please{' '}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${config.url}/personal-investing/help/contact/index.html`}
                  >
                    contact us
                  </a>{' '}
                  to update your date of birth and place your trade over the
                  phone today.
                </div>
              }
            />
          </If>

          {/* Address incomplete submission error */}
          <If test={errorType === ADDRESS_INCOMPLETE}>
            <ErrorPage
              heading={' Missing Address Information'}
              retryMsg={
                <div>
                  <div className="full-page-loader-space">
                    We’re currently missing information for the mailing address
                    connected to your account.
                  </div>
                  To continue,{' '}
                  <a
                    className="full-page-loader-link"
                    href={`${config.url}/usis/my-accounts/profile/contact-information`}
                  >
                    update your address{' '}
                  </a>{' '}
                  or{' '}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${config.url}/personal-investing/help/contact/index.html`}
                  >
                    contact us
                  </a>{' '}
                  to speak with an associate.
                </div>
              }
            />
          </If>

          {/* Foreign Address submission error */}
          <If test={errorType === FOREIGN_ADDRESS}>
            <ErrorPage
              errorMsg={
                <div className="full-page-loader-error-msg">
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      Please{' '}
                      <span>
                        {' '}
                        <a
                          className="college-branded-link full-page-loader-link"
                          href={`${config.url}/personal-investing/help/contact-us.html`}
                        >
                          call us
                        </a>{' '}
                        to speak with a representative.
                      </span>
                    </span>
                  )}
                </div>
              }
              heading={' You have a foreign address on file'}
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      {' '}
                      <a
                        className="full-page-loader-retry-link full-page-loader-retry-pad college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>

          {/* Time out submission error */}
          <If test={errorType === TIMEOUT}>
            <ErrorPage
              errorMsg={
                <div className="full-page-loader-error-msg full-page-loader-error-msg-lh">
                  Transactions may take up to 5 minutes to process. If your
                  transaction was successful,
                  <br />
                  we'll send a notification to your{' '}
                  <a
                    className="full-page-loader-link"
                    href={`${config.rmlUrl}/usis/my-accounts/profile/contact-information`}
                  >
                    contact information on file
                  </a>{' '}
                  and update <br />
                  your{' '}
                  <a
                    className="full-page-loader-link"
                    href={`${config.url}/usis/my-accounts/transactions`}
                  >
                    account activity.
                  </a>
                  <br />
                  <br />
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      Please{' '}
                      {collegeOnlyPlan ? (
                        <span>
                          <a
                            className="college-branded-link full-page-loader-link"
                            href={`${config.url}/personal-investing/help/contact-us.html`}
                          >
                            call us
                          </a>{' '}
                          to to complete this transaction or try again later.
                        </span>
                      ) : (
                        <span>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`${config.url}/personal-investing/help/contact/index.html`}
                          >
                            contact us
                          </a>{' '}
                          for additional assistance.
                        </span>
                      )}
                    </span>
                  )}
                </div>
              }
              heading={`We are having technical issues submitting your ${
                collegeOnlyPlan ? collegeFlowType : mfFlowType
              }.`}
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      {' '}
                      <a
                        className="full-page-loader-retry-link college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                        rel="noopener noreferrer"
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>

          {/* Exchange to existing load failed submission error */}
          <If test={errorType === EXCHANGE_TO_EXISTING_LOAD_FAILED}>
            <ErrorPage
              errorMsg={
                <div className="full-page-loader-error-msg">
                  If the problem persists, please call{' '}
                  <Phone
                    phoneNumber={
                      collegePlanType
                        ? COLLEGE_FUND_NOTE_PHONE_NUMBERS[collegePlanType]
                        : '888-421-0563'
                    }
                  />
                  .
                </div>
              }
              heading={
                <div className="full-page-loader-errorHeader">
                  Unable to load {words.fund} list.
                </div>
              }
            />
          </If>

          {/* MD529 Decommission - zero state error message */}
          <If test={errorType === MD529_DECOMMISSION}>
            <ErrorPage
              heading={
                'Changes have been made to how 529 college savings plan accounts are established and accessed.'
              }
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    For next steps and information on <b>Alaska 529 accounts</b>
                    , review this{' '}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://cdn.unite529.com/jcdn/files/AKD/pdfs/Alaska_529_Account_Owner_Transition_Guide.pdf`}
                      className="contact-link"
                    >
                      Alaska 529 Transition Guide
                    </a>
                    .
                  </div>
                  <br></br>
                  <div>
                    For <b>T. Rowe Price College Savings Plan accounts</b>, to
                    reestablish online access visit{' '}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://www.troweprice529.com`}
                      className="contact-link"
                    >
                      troweprice529.com
                    </a>{' '}
                    and log in to create a new username and password.
                  </div>
                  <br></br>
                  <div>
                    For <b>Maryland College Investment Plan accounts</b>, to
                    reestablish online access visit{' '}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://www.Maryland529.com`}
                      className="contact-link"
                    >
                      Maryland529.com
                    </a>{' '}
                    and log in to create a new username and password.
                  </div>
                  <br></br>
                  <div>
                    If you are logging in to T. Rowe Price to view a custodian
                    account that is not for one of the plans above, such as UGMA
                    or UTMA, log in as the custodian.
                  </div>
                  <br></br>
                  <div>
                    If you believe you are receiving this message in error,{' '}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`${config.url}/personal-investing/help/contact/index.html`}
                      className="contact-link"
                    >
                      contact us
                    </a>{' '}
                    for assistance.
                  </div>
                </div>
              }
            />
          </If>
          {/* Add Bank - Non-Eligible Agreement submission error */}
          <If
            test={
              errorType === NON_ELIGIBLE_AGREEMENTS ||
              errorType === MD529_DECOMMISSION_ZERO_STATE ||
              errorType === CUSTODIAN_ONLY
            }
          >
            <ErrorPage
              heading={unableToAddbank}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    You do not currently own any accounts that are eligible for{' '}
                    adding a bank <br></br>
                    online. To add a bank, please complete the{' '}
                    <a
                      className="error-link"
                      href="https://www.troweprice.com/content/dam/iinvestor/Forms/shrhldrsrvcs.pdf"
                    >
                      Account Services form
                    </a>
                    .
                  </div>
                  <br></br>
                  <div>
                    If you believe you are receiving this message in error,
                    please{' '}
                    <a
                      className="error-link"
                      href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                    >
                      contact us{' '}
                    </a>
                    <br></br>
                    for assistance.
                  </div>
                </div>
              }
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <a
                        className="full-page-loader-retry-link college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                        rel="noopener noreferrer"
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>

          {/* Add Bank - Stop Transfer submission error */}
          <If test={errorType === ANY_STOP_TRANSFER}>
            <ErrorPage
              heading={unableToAddbank}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    Because there is a stop transfer restriction on one or more
                    of your<br></br> accounts, you cannot add a bank online at{' '}
                    this time.
                  </div>
                  <br></br>
                  <a
                    className="error-link"
                    href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                  >
                    Contact us{' '}
                  </a>
                  for more information and to link a new bank account.
                </div>
              }
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <a
                        className="full-page-loader-retry-link college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                        rel="noopener noreferrer"
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>

          {/* Add Bank - 529 Custodian Only submission error */}
          <If test={errorType === COLLEGE_CLIENT_ONLY}>
            <ErrorPage
              heading={unableToAddbank}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    Because you are a custodian on your 529 accounts, you cannot
                    <br></br>
                    add a bank online at this time.
                  </div>
                  <br></br>
                  <div>
                    If you believe you are receiving this message in error,
                    please<br></br>
                    <a
                      className="error-link"
                      href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                    >
                      contact us{' '}
                    </a>
                    for assistance.
                  </div>
                </div>
              }
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <a
                        className="full-page-loader-retry-link college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                        rel="noopener noreferrer"
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>

          {/* Add Bank - TRAC or RPS Only submission error */}
          <If test={errorType === TRAC_OR_RPS_ONLY}>
            <ErrorPage
              heading={unableToAddbank}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    Although you have access to T. Rowe Price services, you are{' '}
                    not the<br></br> owner of record for any accounts. Only{' '}
                    account owners may<br></br> add a bank online.
                  </div>
                  <br></br>
                  <div>
                    If you believe you are receiving this message in error,
                    please<br></br>
                    <a
                      className="error-link"
                      href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                    >
                      contact us
                    </a>{' '}
                    for assistance.
                  </div>
                </div>
              }
              retryMsg={
                <div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <a
                        className="full-page-loader-retry-link college-branded-link"
                        href={`${config.url}/usis/my-accounts/dashboard`}
                        rel="noopener noreferrer"
                      >
                        Return to Dashboard
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>

          {/* Zero balance or College sell redirect submission error */}
          <If
            test={
              errorType === ZERO_BALANCE_FUND ||
              errorType === COLLEGE_SELL_REDIRECT
            }
          >
            <ErrorPage
              heading={'No Funds Eligible for Redemption'}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    You are not able to make a redemption, as your account(s)
                    have zero balance.
                  </div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <div className="full-page-loader-space">
                        {' '}
                        To add additional assets, {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.rmlUrl}/usis/nasu/account-finder`}
                        >
                          open an account here.
                        </a>
                      </div>
                      <span className="full-page-loader-space">
                        If you are trying to place a redemption from another
                        account type, visit the {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}${appendBasePath('/landing')}`}
                        >
                          transaction page.
                        </a>
                      </span>
                    </span>
                  )}
                </div>
              }
            />
          </If>

          {/* No eligible Roth-conversion funds */}
          <If test={errorType === ROTH_CONVERSION_NO_ELIGIBLE_FUNDS}>
            <ErrorPage
              heading={'No Funds Eligible for Roth Conversion'}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    You are not able to make a Roth Conversion, as none are your
                    accounts are eligible.
                  </div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <div className="full-page-loader-space">
                        {' '}
                        To open a Roth IRA, {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}/personal-investing/tools/nasu/mutual-fund/retirement/contributory/roth`}
                        >
                          open an account here.
                        </a>
                      </div>
                      <span className="full-page-loader-space">
                        If you are trying to place a different transaction,
                        visit the {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}${appendBasePath('/landing')}`}
                        >
                          transaction page.
                        </a>
                      </span>
                    </span>
                  )}
                </div>
              }
            />
          </If>
          {/* user tries to access IRA-automax page but has no IRAs */}
          <If test={errorType === NO_ELIGIBLE_FUNDS_IRAS_IRA_AUTOMAX}>
            <ErrorPage
              heading={noFundsEligibleForIRAMax}
              hasError={hasError}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    You are not able to set-up an IRA AutoMax, as you have no
                    eligible account(s).
                  </div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <div className="full-page-loader-space">
                        {' '}
                        To add additional assets, {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}/personal-investing/tools/fund-research/account-finder`}
                        >
                          open an account here.
                        </a>
                      </div>
                      <span className="full-page-loader-space">
                        If you are trying to set-up another automatic
                        transaction from another account type, visit the {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}${appendBasePath(automaticPath)}`}
                        >
                          automatic transaction page.
                        </a>
                      </span>
                    </span>
                  )}
                </div>
              }
            />
          </If>
          {/* user tries to access IRA-automax page but has no IRAs */}
          <If test={errorType === NO_IRA_AUTO_MAX_FUNDS}>
            <ErrorPage
              heading={noFundsEligibleForIRAMax}
              hasError={hasError}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    You've met the IRA annual contribution limit for this year
                    or have a remaining annual IRA contribution that is under
                    $100
                  </div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <div className="full-page-loader-space">
                        {' '}
                        For more information, {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}/usis/my-accounts/taxes`}
                        >
                          View Your Contribution Details.
                        </a>
                      </div>
                      <span className="full-page-loader-space">
                        If you are trying to set-up another automatic
                        transaction from another account type, visit the {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}${appendBasePath(automaticPath)}`}
                        >
                          automatic transaction page.
                        </a>
                      </span>
                    </span>
                  )}
                </div>
              }
            />
          </If>
          {/* user tries to access IRA-automax page but has no IRAs */}
          <If test={errorType === NO_ELIGIBLE_FUNDS_IRAS_IRA_AUTOMAX}>
            <ErrorPage
              heading={noFundsEligibleForIRAMax}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    You are not able to set-up an IRA AutoMax, as you have no
                    eligible account(s).
                  </div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <div className="full-page-loader-space">
                        {' '}
                        To add additional assets, {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}/personal-investing/tools/fund-research/account-finder`}
                        >
                          open an account here.
                        </a>
                      </div>
                      <span className="full-page-loader-space">
                        If you are trying to set-up another automatic
                        transaction from another account type, visit the {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}${appendBasePath(automaticPath)}`}
                        >
                          automatic transaction page.
                        </a>
                      </span>
                    </span>
                  )}
                </div>
              }
            />
          </If>
          {/* user tries to access IRA-automax page but has no IRAs */}
          <If test={errorType === NO_IRA_AUTO_MAX_FUNDS}>
            <ErrorPage
              heading={noFundsEligibleForIRAMax}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    You've met the IRA annual contribution limit for this year
                    or have a remaining annual IRA contribution that is under
                    $100
                  </div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <div className="full-page-loader-space">
                        {' '}
                        For more information, {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}/usis/my-accounts/taxes`}
                        >
                          View Your Contribution Details.
                        </a>
                      </div>
                      <span className="full-page-loader-space">
                        If you are trying to set-up another automatic
                        transaction from another account type, visit the {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}${appendBasePath(automaticPath)}`}
                        >
                          automatic transaction page.
                        </a>
                      </span>
                    </span>
                  )}
                </div>
              }
            />
          </If>
          {/* No eligible Benes in Roth-conversion*/}
          <If test={errorType === ROTH_CONVERSION_NO_ELIGIBLE_BENES}>
            <ErrorPage
              heading={'No Eligible Beneficiaries for Roth Conversion'}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    Before doing a Roth Conversion online your beneficiary
                    designations must be identical for all identically
                    registered accounts.
                  </div>
                  <span>
                    <span className="full-page-loader-space">
                      Please{' '}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`${config.url}/usis/my-accounts/profile/beneficiaries`}
                      >
                        update your beneficiaries
                      </a>{' '}
                      accordingly.
                    </span>
                  </span>
                </div>
              }
            />
          </If>
          {/* College Buy or Exchange redirect submission error */}
          <If
            test={
              errorType === COLLEGE_BUY_REDIRECT ||
              errorType === COLLEGE_EXCHANGE_REDIRECT
            }
          >
            <ErrorPage
              heading={'No Funds Eligible for Transaction'}
              errorMsg={
                <div className="full-page-loader-zero-balance">
                  <div>
                    You are not able to make{' '}
                    {(errorType === COLLEGE_BUY_REDIRECT && 'a purchase') ||
                      (errorType === COLLEGE_EXCHANGE_REDIRECT &&
                        'an exchange')}
                    , as you have no eligible mutual fund accounts.
                  </div>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <div className="full-page-loader-space">
                        {' '}
                        To add additional assets, {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.rmlUrl}/usis/nasu/account-finder`}
                        >
                          open an account here.
                        </a>
                      </div>
                      <span className="full-page-loader-space">
                        If you are trying to place{' '}
                        {(errorType === COLLEGE_BUY_REDIRECT && 'a purchase') ||
                          (errorType === COLLEGE_EXCHANGE_REDIRECT &&
                            'an exchange')}{' '}
                        from another account type, visit the {''}
                        <a
                          className="full-page-loader-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.url}/usis/transactions/landing`}
                        >
                          transaction page.
                        </a>
                      </span>
                    </span>
                  )}
                </div>
              }
            />
          </If>
        </If>

        <If test={isVisible}>
          <div className="full-page-loader-loading-screen">
            <div className="full-page-loader-loader-container">
              {!isQCD() && (
                <div className="full-page-loader-loading-msg">{message}</div>
              )}
              <Loader isVisible={isVisible} />
            </div>
          </div>
        </If>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    collegeOnlyPlan: getHasCollegeOnly(state),
  };
};

export default compose(connect(mapStateToProps))(FullPageLoader);
